/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Component imports.
 */
import { HcfOuterComponent } from './hcf-outer/hcf-outer.component';
import { HcfTemplateComponent } from './templates/hcf-template/hcf-template.component';

/**
 * Module import.
*/
import { ProductMaskingCardModule } from '../common/product-masking-card/product-masking-card.module';

/**
 * Pipe import.
 */
import { HcfTemplateFilterPipe } from './template.pipe';

@NgModule({
  declarations: [
    HcfOuterComponent,
    HcfTemplateComponent,
    HcfTemplateFilterPipe
  ],
  imports: [
    CommonModule,
    ProductMaskingCardModule
  ],
  exports: [
    HcfOuterComponent,
    HcfTemplateComponent,
    HcfTemplateFilterPipe
  ]
})
export class HcfModule { }
